<div
  class="scroll-container"
  infiniteScroll
  [infiniteScrollContainer]="'.mat-drawer-content'"
  [fromRoot]="true"
  [scrollWindow]="true"
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollUpDistance]="scrollUpDistance"
  [infiniteScrollThrottle]="throttle"
  (scrolled)="onScrollDown($event)"
>
  <div class="container">
    <div class="container-screen-content">
      <div class="divsearch-userlist">
        <app-icon-text-button
          *appIfRoles="profilesEligibleToCreateUser"
          text="Criar novo usuário"
          imagePath="../../../../assets/icons/add-usuario.svg"
          route="user-form"
        ></app-icon-text-button>
        <app-search-bar
          actionText="Pesquisar"
          placeholder="Pesquise pelo nome ou e-mail"
          (search)="filter($event)"
        ></app-search-bar>
        <!-- filters -->
        <div class="filters">
          <app-year-select
            #yearSelectId
            [idSchool]="idsSchool ? idsSchool[0] : ''"
            [selectedYear]="yearFilter"
            (selectEvent)="handleSelectYear($event)"
          ></app-year-select>
          <app-classroom-select
            [year]="yearFilter"
            [initialIds]="classroomsFilter"
            (selectEvent)="handleSelectClassroom($event)"
            (loaded)="onClassroomsLoaded($event)"
          ></app-classroom-select>
          <app-profile-select
            [initialIds]="profilesFilter"
            [allProfiles]="true"
            (selectEvent)="handleSelectProfiles($event)"
          ></app-profile-select>
          <app-user-active-select
            [active]="activeUsersFilter"
            (activeChange)="handleSelectActiveUsers($event)"
          ></app-user-active-select>
          <button
            (click)="handleClearFilter()"
            class="clear-button"
            [disabled]="disableResetFilters"
            mat-button
          >
            Limpar filtros
          </button>
        </div>
        <!-- end filters -->
      </div>

      <div class="spinner-container" *ngIf="loading">
        <mat-spinner diameter="70" class="custom-spinner"></mat-spinner>
      </div>

      <div *ngIf="countUsers! > 1; else singular" class="count-users">
        {{ countUsers }} registros encontrados
      </div>
      <ng-template #singular>
        <div class="count-users">
          {{ countUsers! > 0 ? countUsers : "nenhum" }} registro encontrado
        </div>
      </ng-template>

      <div class="cells-container">
        <app-user-card
          *ngFor="let user of users"
          [userInfo]="user"
          (click)="updatePage(user.id)"
        >
        </app-user-card>
      </div>
    </div>
  </div>
</div>
